import React, { FC } from 'react'
import { SpeakerTextContainer } from './style'
import { SpeakerContent } from './subcomponents/speakerContent'

//* utils
import { ComponentSpeakerText } from '../../../models/components/speakerText'
import ImgUtil from '../../../utils/img.utils'
import speakerTextMicrocopy from './speakerBiosStaticQuery'

type Props = {
  data: ComponentSpeakerText
}

const SpeakerText: FC<Props> = ({ data }) => {
  if (!data) return null
  const microCopyStaticQuery = speakerTextMicrocopy.allContentfulSpeakerBiosMicrocopy()

  const speakerTextData = {
    microcopy: data.speakerBiosMicrocopy || microCopyStaticQuery,
    useCase: data.useCase || '',
    mainImage: data.mainImage
      ? {
          url: data.mainImage?.image?.file?.url,
          altText: data.mainImage?.altText,
          youtubeId: 'youtubeId' in data.mainImage && data.mainImage.youtubeId,
          vimeoId: 'vimeoId' in data.mainImage && data.mainImage.vimeoId,
          videoUrl: 'videoUrl' in data.mainImage && data.mainImage.videoUrl,
          tencentVideoUrl: 'tencentVideoUrl' in data.mainImage && data.mainImage.tencentVideoUrl,
          start: 'start' in data.mainImage && data.mainImage.start,
          __typename: data.mainImage?.__typename,
        }
      : {},
    accent: {
      url: data.accentImage?.image?.file?.url || '',
      altText: data.accentImage?.altText || '',
      number: data.accentNumber || '',
    },
    eyebrow: data.eyebrow || '',
    title: data.title || '',
    theme: data.theme || '',
    speakers: data.speakers || [],
    speakerLabel: data.speakerLabel || '',
    description: data.description || '',
    backgroundImg: data.background?.image?.file?.url
      ? ImgUtil.getResizedImageUrl(data.background.image.file.url, ``)
      : '',
  }

  return (
    <SpeakerTextContainer
      $background={speakerTextData.backgroundImg}
      $backgroundTheme={speakerTextData.theme}
      $mainImage={!!speakerTextData.mainImage.url}
      $useCase={speakerTextData.useCase}
      data-cy="SpeakerText">
      <div className="SpeakerText__Dots"></div>
      <SpeakerContent data={data} speakerTextData={speakerTextData} />
    </SpeakerTextContainer>
  )
}

export default SpeakerText
